import { render, staticRenderFns } from "./StokListDetayButon.vue?vue&type=template&id=66a00f13"
import script from "./StokListDetayButon.vue?vue&type=script&lang=js"
export * from "./StokListDetayButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports